import { EnvironmentConfig } from '../app/config/config.service';

export const environment: EnvironmentConfig = {
	production: true,
};
